module.exports = __webpack_public_path__ + "23cb97f0.svg";